export default "__VITE_ASSET__GoCnFxhF__"